var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueRngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4983 7.242L17.1339 3.56063L15.746 0.75H8.25238L6.86412 3.56063L10.5001 7.242C6.81275 7.9545 4.01562 11.2369 4.01562 15.1721C4.01563 19.6267 7.59725 23.25 11.999 23.25C16.4008 23.25 19.9824 19.6267 19.9824 15.1721C19.9824 11.2369 17.1853 7.95412 13.4983 7.242ZM12.5169 5.50313H11.4751L10.9306 3.85238H13.061L12.5169 5.50313ZM15.2949 1.476L16.1101 3.12675H13.8717L13.6029 1.476H15.2949ZM13.8256 3.85238H15.8259L14.1946 5.50313H13.2815L13.8256 3.85238ZM11.1297 1.476H12.8675L13.1364 3.12675H10.8564L11.1297 1.476ZM8.70312 1.476H10.3944L10.121 3.12675H7.88788L8.70312 1.476ZM8.171 3.85238H10.1664L10.7105 5.50313H9.79663L8.171 3.85238ZM11.999 22.524C7.997 22.524 4.74125 19.2259 4.74125 15.1721C4.74125 11.1184 7.99738 7.81988 11.999 7.81988C16.0006 7.81988 19.2564 11.118 19.2564 15.1721C19.2564 19.2262 16.001 22.524 11.999 22.524Z",
    fill: "#5078C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8851 8.72656C8.33875 8.72656 5.45312 11.6456 5.45312 15.2332C5.45312 18.8212 8.33875 21.7402 11.8851 21.7402C15.4315 21.7402 18.3171 18.8216 18.3171 15.2332C18.3171 11.6456 15.4315 8.72656 11.8851 8.72656ZM11.8851 21.0142C8.7385 21.0142 6.17875 18.4207 6.17875 15.2332C6.17875 12.0457 8.73888 9.45219 11.8851 9.45219C15.0314 9.45219 17.5911 12.0457 17.5911 15.2332C17.5911 18.4207 15.0318 21.0142 11.8851 21.0142Z",
    fill: "#5078C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRngIcon);
export default __webpack_public_path__ + "static/media/BlueRngIcon.1ea2b37f159983b9fbc4b6ce33492807.svg";
export { ForwardRef as ReactComponent };